<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="门票退款" name="1" v-if="role.includes('v1.window.order.refund.ticket')">
          <refund_ticket :reason="reason" ref="refund_ticket"></refund_ticket>
        </el-tab-pane>
        <el-tab-pane label="年卡退款" name="2" v-if="role.includes('v1.window.order.refund.yearCard')">
          <refund_yearCard :reason="reason" ref="refund_yearCard"></refund_yearCard>
        </el-tab-pane>
      </el-tabs>

      <div class="flex flex_end end-silder flex_items">
        <el-input placeholder="备注" style="width: 250px;font-size: 16px;" v-model="reason" class="mr20"></el-input>
        <el-button type="primary" style="width: 150px;font-size: 16px;" @click="makeup">退款</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import refund_ticket from './compoenets/refund_ticket.vue';
import refund_yearCard from './compoenets/refund_yearCard.vue';
export default {
  data() {
    return {
      list: [],
      activeName: '1',
      options: [],
      keyword: '',
      status: '',
      type: '',
      reason: '',
      role: []
    };
  },
  components: {
    refund_ticket, refund_yearCard
  },
  methods: {
    indexMethod(e) {
      return (e + 1) + this.pageSize * (this.currentPage - 1)
    },
    makeup() {
      this.$nextTick(r => {
        if (this.activeName == 1) {
          this.$refs.refund_ticket.makeup()
        } else {
          this.$refs.refund_yearCard.makeup()
        }
      })
    },
    handleClick() {
      this.$nextTick(_ => {
        if (this.activeName == 1) {
          this.$refs.refund_ticket.search()
        } else {
          this.$refs.refund_yearCard.search()
        }
      })
    }
  },
  created() {
    this.handleClick()
    this.role = this.$store.getters.roles ? this.$store.getters.roles : [];
    if (this.$route.query.type == 2) {
      this.activeName = '2'
    } else {
      if (this.role.includes('v1.window.order.refund.ticket')) {
        this.activeName = '1'
      } else {
        this.activeName = '2'
      }
    }

  },
};
</script>
<style scoped>
.end-silder {
  position: absolute;
  bottom: 0;
  left: 130px;
  height: 80px;
  background: #f3eded;
  width: calc(100% - 130px);
  padding-right: 30px;
  box-sizing: border-box;
}
</style>
